import { ArrowUpRight } from "lucide-react";
import { TREATMENTS } from "@/data/treatments";
import { Reveal } from "./Reveal";

const handleMove = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};

export default function Treatments() {
  return (
    <section id="treatments" className="scroll-mt-28 bg-cream py-28 sm:py-36" data-testid="treatments-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal className="max-w-2xl">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">Nine specialties, one standard</p>
          <h2 className="mt-5 font-serif text-4xl font-medium leading-[1.08] tracking-tight text-brand-green sm:text-5xl">
            Procedures performed by India's most decorated surgeons.
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {TREATMENTS.map((t, i) => (
            <Reveal key={t.id} delay={(i % 3) * 0.1}>
              <article
                onMouseMove={handleMove}
                data-testid={`treatment-card-${t.id}`}
                className="group relative h-full overflow-hidden rounded-3xl border border-sand bg-white transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_30px_70px_rgba(8,61,52,0.14)]"
              >
                <div
                  className="pointer-events-none absolute inset-0 z-10 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
                  style={{ background: "radial-gradient(260px circle at var(--mx) var(--my), rgba(197,155,98,0.18), transparent 70%)" }}
                />
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={t.image}
                    alt={t.name}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-deep/45 to-transparent" />
                  <span className="absolute left-5 top-5 rounded-full bg-ivory/90 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-brand-green backdrop-blur">
                    {t.category.split("·")[0]}
                  </span>
                </div>
                <div className="p-7">
                  <h3 className="font-serif text-2xl font-semibold text-ink">{t.name}</h3>
                  <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-gold">{t.stay}</p>
                  <ul className="mt-5 space-y-2.5">
                    {t.highlights.map((h) => (
                      <li key={h} className="flex items-start gap-2.5 text-sm text-ash">
                        <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-gold" />
                        {h}
                      </li>
                    ))}
                  </ul>
                  <a
                    href="#quote"
                    data-testid={`treatment-quote-link-${t.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="mt-7 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-green transition-colors duration-300 hover:text-gold"
                  >
                    Request case review
                    <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
